import { createI18n } from 'vue-i18n';
import pinia from '/@/stores/index';
import { storeToRefs } from 'pinia';
import { useThemeConfig } from '/@/stores/themeConfig';

// 定义语言国际化内容

/**
 * 说明：
 * 须在 pages 下新建文件夹（建议 `要国际化界面目录` 与 `i18n 目录` 相同，方便查找），
 * 注意国际化定义的字段，不要与原有的定义字段相同。
 * 1、/src/i18n/lang 下的 ts 为框架的国际化内容
 * 2、/src/i18n/* 下的 ts 为各模块的国际化内容
 */

import enLocale from 'winbox-ui-next/es/locale/lang/en-us';
import zhLocale from 'winbox-ui-next/es/locale/lang/zh-cn';
import zTLocale from 'winbox-ui-next/es/locale/lang/zh-tw';



// 定义变量内容
const element = { 'en-US': enLocale, 'zh-cn': zhLocale, 'zh-HK': zTLocale };
const modules: Record<string, any> = import.meta.glob('./**/*.ts', { eager: true });

// 对自动引入的 modules 进行分类 en、zh-cn
const moduleCategories = Object.keys(modules).reduce((acc, path) => {
	const key = path.match(/(\S+)\/(\S+).ts/);
	const moduleName = key![1].split('/')[1]; // 获取模块名，作为 key
	const mapModuleName = moduleName === 'lang' ? 'message' : moduleName; // 兼容lang目录下的配置文件
	const mapModuleKey = key![2];

	// 通过模块名，将模块内容分类
	acc[mapModuleKey] = Object.assign(acc[mapModuleKey] || {}, { [mapModuleName]: modules[path].default });

	return acc;
}, {});

// 合并语言国际化内容
const messages = Object.keys(moduleCategories).reduce((acc, key) => {
	acc[key] = Object.assign({}, moduleCategories[key], element[key]);
	return acc;
}, {});

// 读取 pinia 默认语言
const stores = useThemeConfig(pinia);
const { themeConfig } = storeToRefs(stores);

// 导出语言国际化
// https://vue-i18n.intlify.dev/guide/essentials/fallback.html#explicit-fallback-with-one-locale
export const i18n = createI18n({
	legacy: false,
	silentTranslationWarn: true,
	missingWarn: false,
	silentFallbackWarn: true,
	fallbackWarn: false,
	locale: themeConfig.value.globalI18n,
	fallbackLocale: zhLocale.name,
	messages,
});
